import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getGamesListThunk } from 'redux-thunk/thunk/lobbyGameManagement.thunk'

const isInactiveStatus = (status) => status === false || status === 'false' || status === 0 || status === '0'

export const useGameAvailability = (gameId) => {
  const dispatch = useDispatch()
  const numericId = Number(gameId)
  const hasGameId = Number.isInteger(numericId) && numericId > 0
  const { games = [], gamesLoaded = false } = useSelector((state) => state.lobby || {})
  const game = hasGameId
    ? (games || []).find((item) => Number(item?.id) === numericId)
    : null

  useEffect(() => {
    if (!hasGameId || gamesLoaded) return
    dispatch(getGamesListThunk())
  }, [dispatch, gamesLoaded, hasGameId])

  return {
    checking: hasGameId && !gamesLoaded,
    inactive: Boolean(game) && isInactiveStatus(game.status),
    gameName: game?.name || ''
  }
}
